import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Cheats are opt-in for every player during early development. The server no longer
 * restricts them to admins, so this flag is purely a client-side visibility switch:
 * it controls whether cheat affordances are rendered at all. Turning it off returns the
 * game to its intended, unassisted experience.
 */
interface CheatState {
  cheatsEnabled: boolean;
  setCheatsEnabled: (enabled: boolean) => void;
  toggleCheats: () => void;
}

export const useCheatStore = create<CheatState>()(
  persist(
    (set) => ({
      cheatsEnabled: false,
      setCheatsEnabled: (enabled) => set({ cheatsEnabled: enabled }),
      toggleCheats: () => set((s) => ({ cheatsEnabled: !s.cheatsEnabled })),
    }),
    {
      name: 'hexcrawl-cheats',
      partialize: (state) => ({ cheatsEnabled: state.cheatsEnabled }),
    }
  )
);

/** Convenience selector for components that only need the on/off flag. */
export const useCheatsEnabled = (): boolean => useCheatStore((s) => s.cheatsEnabled);
